/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetCardsResponseCardsItemProductCardImageDetailsOneOfCardOrientation = typeof GetCardsResponseCardsItemProductCardImageDetailsOneOfCardOrientation[keyof typeof GetCardsResponseCardsItemProductCardImageDetailsOneOfCardOrientation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardsResponseCardsItemProductCardImageDetailsOneOfCardOrientation = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
} as const;
